function getShadowHost(el: HTMLElement): HTMLElement | null {
  const root = el.getRootNode();
  return (root instanceof ShadowRoot ? root.host : null) as HTMLElement | null;
}

/**
 *
 *
 *
 *
 *
 *
 *
 */
export const findClippingElement = (element: HTMLElement): HTMLElement | null => {
  let current: HTMLElement | null = element;

  while (current) {
    const style = window.getComputedStyle(current);
    const overflowY = style.overflowY;
    const overflowX = style.overflowX;

    if (
      (overflowY == "auto" ||
        overflowY == "scroll" ||
        overflowX == "auto" ||
        overflowX == "scroll" ||
        overflowX == "hidden" ||
        overflowY == "hidden") &&
      current.tagName !== "HTML"
    ) {
      return current;
    }

    current = current.assignedSlot || current.parentElement || getShadowHost(current);
  }
  if (current && (current as HTMLElement).tagName === "HTML") {
    return null;
  }
  return null;
};

export const findScrollingElement = (element: HTMLElement): HTMLElement | null => {
  let current: HTMLElement | null = element;

  while (current) {
    const style = window.getComputedStyle(current);
    const overflowY = style.overflowY;
    const overflowX = style.overflowX;

    if (
      (overflowY == "auto" ||
        overflowY == "scroll" ||
        overflowX == "auto" ||
        overflowX == "scroll") &&
      current.tagName !== "HTML"
    ) {
      return current;
    }

    current = current.assignedSlot || current.parentElement || getShadowHost(current);
  }
  if (current && (current as HTMLElement).tagName === "HTML") {
    return null;
  }
  return null;
};

/**
 *
 *
 *
 *
 *
 *
 *
 */

export const findViewportElement = (element: HTMLElement): HTMLElement | null => {
  /*                                                        */
  let el: HTMLElement | null = element;
  while (el) {
    const styles = window.getComputedStyle(el);
    const transform = styles.getPropertyValue("transform");
    const filter = styles.getPropertyValue("filter");
    const perspective = styles.getPropertyValue("perspective");
    const willChange = styles.getPropertyValue("will-change");
    if (
      (transform && transform !== "none") ||
      (filter && filter !== "none") ||
      (perspective && perspective !== "none") ||
      (willChange && willChange == "transform") ||
      (willChange && willChange == "filter")
    ) {
      return el;
    }
    el = el.assignedSlot || el.parentElement || getShadowHost(el);
  }
  return null;
};
